import React from 'react'
import ModalWrapper from '../ModalWrapper'
import RevertProCancellationContainer from '../../../containers/account/RevertProCancellationContainer'

const RevertProCancellationModal = (props) => (
  /* eslint-disable react/jsx-props-no-spreading */
  <ModalWrapper
    {...props}
    title='Keep Plickers Pro'
    iconName=''
    closeBtn={false}
    showModalHeader={false}
    modalStyle='dark'
  >
    <RevertProCancellationContainer {...props} />

  </ModalWrapper>
  /* eslint-enable react/jsx-props-no-spreading */

)

export default RevertProCancellationModal
